export enum MessageProvider {
  Sendgrid = 'Sendgrid',
  Smtp = 'Smtp',
  BrevoSmtp = 'BrevoSmtp'
}
